import Flex from "./Flex";
import { RangeType, Value } from "./calendarTypes";
import { getTileClasses } from "./helpers/getTileClasses";
import styles from "../Calendar.module.scss";

type TileGroupProps = {
  className?: string;
  count?: number;
  dateTransform: (point: number) => Date;
  dateType: RangeType;
  end: number;
  hover?: Date | null;
  offset?: number;
  renderTile: (props: { classes: string[]; date: Date }) => React.ReactElement;
  start: number;
  step?: number;
  value?: Value;
};

export default function TileGroup({
  className,
  count = 3,
  dateTransform,
  dateType,
  end,
  hover,
  offset,
  renderTile,
  start,
  step = 1,
  value,
  ...otherProps
}: TileGroupProps): React.ReactElement {
  const tiles = [];
  for (let point = start; point <= end; point += step) {
    const date = dateTransform(point);

    tiles.push(
      renderTile({
        classes: getTileClasses({
          date,
          dateType,
          hover,
          value,
          valueType: "month",
          stylesMap: styles,
        }),
        date,
      })
    );
  }

  return (
    <Flex className={className} count={count} offset={offset} wrap style={{ gap: "2%" }} {...otherProps}>
      {tiles}
    </Flex>
  );
}
